import { api, createCancelTokenHandler } from "../utils";

const endPoint = () => window._env_.REACT_APP_PASSPORT_END_POINT;

const Repository = {
  select: function (params: any = null) {
    return api.get(`${endPoint()}/api/select/order-delivery`, {
      params,
      cancelToken:
        cancelTokenHandlerObject[this.select.name].handleRequestCancellation()
          .token,
    });
  },
  findAll: function (params: any = null) {
    return api.get(`${endPoint()}/api/order-delivery`, {
      params,
      cancelToken:
        cancelTokenHandlerObject[this.findAll.name].handleRequestCancellation()
          .token,
    });
  },
  findOne: function (id: number | string, params: any = null) {
    return api.get(`${endPoint()}/api/order-delivery/${id}`, {
      params,
      cancelToken:
        cancelTokenHandlerObject[this.findOne.name].handleRequestCancellation()
          .token,
    });
  },
  create: function (payload: any, params: any = null) {
    return api.post(`${endPoint()}/api/order-delivery`, payload, {
      params,
      cancelToken:
        cancelTokenHandlerObject[this.create.name].handleRequestCancellation()
          .token,
    });
  },
  update: function (id: number | string, payload: any, params: any = null) {
    return api.put(`${endPoint()}/api/order-delivery/${id}`, payload, {
      params,
      cancelToken:
        cancelTokenHandlerObject[this.update.name].handleRequestCancellation()
          .token,
    });
  },
  delete: function (id: number | string, params: any = null) {
    return api.delete(`${endPoint()}/api/order-delivery/${id}`, {
      params,
      cancelToken:
        cancelTokenHandlerObject[this.delete.name].handleRequestCancellation()
          .token,
    });
  },
  detailCode: function (id: number | string, params: any = null) {
    return api.get(`${endPoint()}/api/order-delivery/${id}/detail-code`, {
      params,
      cancelToken:
        cancelTokenHandlerObject[
          this.detailCode.name
        ].handleRequestCancellation().token,
    });
  },
  detailGift: function (id: number | string, params: any = null) {
    return api.get(`${endPoint()}/api/order-delivery/${id}/detail-gift`, {
      params,
      cancelToken:
        cancelTokenHandlerObject[
          this.detailGift.name
        ].handleRequestCancellation().token,
    });
  },
  export: function (id: number | string, params: any = null) {
    return api.get(`${endPoint()}/api/order-delivery/${id}/excel`, {
      params,
      responseType: "blob",
      cancelToken:
        cancelTokenHandlerObject[this.export.name].handleRequestCancellation()
          .token,
    });
  },
};

const cancelTokenHandlerObject = createCancelTokenHandler(Repository);

export default Repository;
